/* src/app/shared/components/loader/loader.component.scss */
.loader-container {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 45%;
  top: 45%;
  z-index: 10000;
}
.loader-container ods-loader {
  width: 3.125rem;
}
/*# sourceMappingURL=loader.component.css.map */
